import { Button, Tab, Tabs } from '@material-ui/core';
import React, { useReducer, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IntegrationSource from '../../../../../../shared/integration-source/IntegrationSource';
import { notificationManager } from '../../../../../../utils/NotificationUtils';
import { updateHKSyncConfigs } from '../../../../../../utils/PropertyAPIUtils';
import {
  allPropertyConfigsSelector,
  fetchAllPropertyConfigData,
} from '../../../../../property/propertySlice';

const Housekeeping = ({ selectedHotel, showLoader = () => {} }) => {
  const dispatch = useDispatch();
  const propertyConfigs = useSelector(allPropertyConfigsSelector);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    vendor: {
      value: '',
      fieldName: 'Vendor',
      errors: {},
      validations: ['required'],
    },
    activeInactive: {
      value: 'Active',
      fieldName: 'activeInactive',
      errors: {},
      validations: [],
    },
    integrationSource: {
      value: '',
      fieldName: 'Integration Source',
      errors: {},
      validations: [],
    },
    integrationSourceSelected: {
      value: '',
      fieldName: '',
      errors: {},
      validations: [],
    },
    hostingType: {
      value: false,
      fieldName: 'On-Prem Hosting',
      errors: {},
      validations: [],
    },
  });
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    if (selectedHotel) {
      dispatch(fetchAllPropertyConfigData(selectedHotel));
    }
  }, [selectedHotel]);

  const onSubmit = (e) => {
    try {
      e.preventDefault();
      // api required
      notificationManager('success', 'Housekeeping configuration save successfully');
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'Error occurred while saving housekeeping configuration',
      );
    }
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else {
      setTabValue(newValue);
    }
  };

  const onClickSync = async (event) => {
    try {
      const res = await updateHKSyncConfigs(selectedHotel, event.target.checked);
      dispatch(fetchAllPropertyConfigData(selectedHotel));
      notificationManager(
        res?.data?.updateHKSyncConfig?.status ? 'success' : 'danger',
        res?.data?.updateHKSyncConfig?.message,
      );
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <form onSubmit={onSubmit} noValidate>
      <div className='col-12 hotel-service-tab-section'>
        <div className='col col-xl-6'>
          <Tabs
            value={tabValue}
            variant='fullWidth'
            indicatorColor='primary'
            onChange={handleTabChange}
            aria-label='roomTypes-add-tabs'
            textColor='primary'
            className='property-tabs'
          >
            <Tab label='Integration Settings' />
            <Tab label='Configurable features' />
          </Tabs>
        </div>
      </div>
      {tabValue === 0 && (
        <div className='mx-4'>
          <IntegrationSource
            formData={formData}
            setFormData={setFormData}
            section='Housekeeping Systems'
            headTitle='Housekeeping system'
            allowInctive={true}
            onClickSync={onClickSync}
            showLoader={showLoader}
            checked={propertyConfigs?.hk?.isEnabled}
            isSyncEnabled
          />
          <div className='row mt-auto px-4 w-100 pb-5'>
            <div className='col-md-12 mt-3  d-flex justify-content-start'>
              <Button
                variant='contained'
                type='submit'
                color='primary'
                className='me-3'
                size='large'
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      )}
    </form>
  );
};

export default Housekeeping;
